import React from 'react';
import { BookmarkContainer } from './bookmarkStyles';
import { BookmarkIcon } from '../Icons/Icons';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { isEqual } from 'lodash';
import {
	BOOKMARK_ADD_STORIES,
	BOOKMARK_DEL_STORIES,
	BookmarkReducerAction,
} from '../../../state/bookmarksSlice';

type BookmarkButtonProps = {
	storyId: number;
};

const BookmarkStoryButton: React.FC<BookmarkButtonProps> = ({ storyId }) => {
	const dispatch = useAppDispatch();
	const bookmarkedStories = useAppSelector(
		(state: RootState) => state.bookmarks.stories,
		isEqual,
	);
	const isBookmarked = bookmarkedStories.includes(storyId);

	const handleToggleBookmark = () => {
		switch (isBookmarked) {
			case true:
				dispatch({
					type: BOOKMARK_DEL_STORIES,
					payload: {
						action_id: storyId,
					},
				} as BookmarkReducerAction);
				break;

			default:
				dispatch({
					type: BOOKMARK_ADD_STORIES,
					payload: {
						action_id: storyId,
					},
				} as BookmarkReducerAction);
		}
	};
	// const handleClick = () => {
	// 	onClick();
	// 	console.log(
	// 		'bookmark toggle requested, current state : ',
	// 		isBookmarked,
	// 	);
	// 	// TODO: Dispatch Bookmark Reducer Action
	// };
	return (
		<BookmarkContainer
			onClick={() => handleToggleBookmark()}
			className={isBookmarked ? 'bookmarked' : ''}>
			<BookmarkIcon />
		</BookmarkContainer>
	);
};

export default BookmarkStoryButton;
